import "../../_generated_templates.js";
window.AssessmentBuilder ??= {};
window.AssessmentBuilder.Views ??= {};

AssessmentBuilder.Views.SubmitterInfo = class SubmitterInfo extends Backbone.View {
  constructor() {
    super(...arguments);
    this.render = this.render.bind(this);
    this.select = this.select.bind(this);
    this.unselect = this.unselect.bind(this);
  }

  render() {
    this.$el.html(this.template(this.model.attributes));
    return this;
  }

  // HELPER FUNCTIONS

  select() {
    const changed = !this.selected;
    this.selected = true;
    this.$el.find(".submitter-info").addClass(this.selectedCss);

    return changed;
  }

  unselect() {
    const changed = this.selected;
    this.selected = false;
    this.$el.find(".submitter-info").removeClass(this.selectedCss);

    return changed;
  }

  // EVENT HANDLERS

  triggerSubmitterInfoClicked() {
    return this.$el.trigger(AssessmentBuilder.Events.SubmitterInfo.clicked);
  }
};
AssessmentBuilder.Views.SubmitterInfo.prototype.tagName = "submitter-info-element";
AssessmentBuilder.Views.SubmitterInfo.prototype.selectedCss = "selected";
AssessmentBuilder.Views.SubmitterInfo.prototype.template = _.template(
  AssessmentBuilder.Templates.SubmitterInfo.submitter_info,
);
AssessmentBuilder.Views.SubmitterInfo.prototype.events = { "click .submitter-info": "triggerSubmitterInfoClicked" };
